import React from 'react';
import { getReactionDisplay, REACTION_TONE_STYLES } from '../../utils/reactionConfig';

const MessageReactionBadge = ({
  reactionId,
  count,
  isOwn,
  isActive,
  isWorkflow,
  onClick,
}) => {
  const display = getReactionDisplay(reactionId);
  const countLabel = count > 0 ? count : 0;
  const altText = display.label || display.emoji;

  if (display.type === 'workflow' || isWorkflow) {
    const toneStyle = REACTION_TONE_STYLES[display.tone] || REACTION_TONE_STYLES.slate;
    const colorClasses = isOwn ? toneStyle.own : toneStyle.other;
    return (
      <button
        type="button"
        onClick={onClick}
        className={`flex items-center gap-1 min-h-6 px-2 py-0.5 rounded-full text-xs border transition-colors flex-shrink-0 ${colorClasses} ${
          isOwn ? 'hover:bg-white/25' : 'hover:brightness-95 dark:hover:brightness-110'
        }`}
        title={altText}
        aria-label={altText}
      >
        <span className="text-sm leading-none flex-shrink-0" role="img" aria-label={altText}>
          {display.emoji}
        </span>
        <span className="text-[10px] font-semibold leading-tight" aria-hidden="true">
          {display.label}
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center gap-1 h-6 px-2 rounded-full text-xs transition-colors flex-shrink-0 shadow-none ${
        isOwn
          ? `bg-white/20 dark:bg-white/10 hover:bg-white/30 dark:hover:bg-white/20 text-white border border-white/30${isActive ? ' bg-white/35 border-white/50' : ''}`
          : `bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-900 dark:text-white border border-gray-200 dark:border-gray-600${isActive ? ' bg-primary-50 dark:bg-primary-900/30 border-primary-300 dark:border-primary-600' : ''}`
      }`}
      title={isActive ? `Remove your ${altText}` : altText}
      aria-label={isActive ? `Remove your ${altText}` : altText}
      aria-pressed={isActive}
    >
      <span className="text-sm leading-none flex-shrink-0" role="img" aria-label={altText}>
        {display.emoji}
      </span>
      <span className={`text-[10px] font-bold leading-none ${isOwn ? 'text-white' : 'text-gray-600 dark:text-gray-300'}`}>
        {countLabel}
      </span>
    </button>
  );
};

export default MessageReactionBadge;
